import axios from "axios";
import { API_URL } from "../../config/config";
import API from "../../common/API";

/*** 
@purpose : Get employee by wwid
@Parameter : {}
**/
export const fetchEmployeeName =  (data) => dispatch => {
  let timestamp = new Date().getTime()
  let actionType = "";
  if(data.page === "dailySellout") {
    actionType = "DAILY_SELLOUT"
  } else if(data.page === "dailySelloutCA") {
    actionType = "DAILY_SELLOUT_CA"
  } else if(data.page === "monthlySellout") {
    actionType = "MONTHLY_SELLOUT"
  } else if(data.page === "monthlySelloutCA") {
    actionType = "MONTHLY_SELLOUT_CA"
  } else if(data.page === "selloutFacility") {
    actionType = "SELLOUT_FACILITY"
  } else if(data.page === "selloutWholesaler") {
    actionType = "SELLOUT_WHOLESALER"
  }
  axios.get(API_URL + API.GET_EMPLOYEE_NAME + `?wwid=${data.wwid}&timestamp=${timestamp}`, {headers: { 'x-api-key': sessionStorage.getItem("token"), 'Access-Control-Allow-Origin': '*'}})
  .then((response) => {
    if (response.data.success == true && response.data.data) {
        dispatch({type: actionType, payload: response.data.data})
    }
  });
};

/*** 
@purpose : Get employee list
@Parameter : {}
**/
export const fetchEmployeeData =  (data) => dispatch => {
  let actionType = "";
  if(data.page === "dailySellout") {
    actionType = "DAILY_SELLOUT"
  } else if(data.page === "dailySelloutCA") {
    actionType = "DAILY_SELLOUT_CA"
  } else if(data.page === "monthlySellout") {
    actionType = "MONTHLY_SELLOUT"
  } else if(data.page === "monthlySelloutCA") {
    actionType = "MONTHLY_SELLOUT_CA"
  } else if(data.page === "selloutFacility") {
    actionType = "SELLOUT_FACILITY"
  } else if(data.page === "selloutWholesaler") {
    actionType = "SELLOUT_WHOLESALER"
  }
  dispatch({type: actionType, payload: data.data})
};


export const fetchEmployeeListing = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_EMPLOYEE_LISTING, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Fetch employee name
@Parameter : {}
**/
export const fetchEmployee = async (wwid) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_EMPLOYEE_NAME + `?wwid=${wwid}&timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
  .then((response) => {
    if (response.data.success == true && response.data.data) {
       return response.data
    }
  });
};

/*** 
@purpose : Get organization list
@Parameter : {}
**/
export const fetchOrganizationList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_ORGANIZATION_LIST + `?timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get target period
@Parameter : {}
**/
export const fetchTargetPeriod = async (name) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_TARGET_PERIOD + `?report_type=${name}&timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get fixed month dated
@Parameter : {}
**/
export const fetchFixedMonth = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_FIXED_MONTH + `?timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get product type list
@Parameter : {}
**/
export const fetchProductTypeList = async (name) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_PRODUCT_TYPE_LIST + `?timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get target period
@Parameter : {}
**/
export const fetchHempLawList = async (name) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_HEMP_LAW_LIST + `?timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get territory definition list
@Parameter : {}
**/
export const fetchProductsList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_PRODUCT_LIST + `?timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get daily sellout report list
@Parameter : {}
**/
export const fetchMarketAuthorizationList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_MARKET_AUTHORIZATION_LIST, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) { 
      return data;
    });
};

/*** 
@purpose : Get daily sellout report list
@Parameter : {}
**/
export const fetchFormList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_FORM_LIST, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) { 
      return data;
    });
};

/*** 
@purpose : Get daily sellout report list
@Parameter : {}
**/
export const fetchFormulationList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_FORMULATION_LIST, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) { 
      return data;
    });
};

/*** 
@purpose : Get packaging list
@Parameter : {}
**/
export const fetchPackagingList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_PACKAGING_LIST, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) { 
      return data;
    });
};

/*** 
  @purpose : Get hundred beds list
  @Parameter : {}
  **/
  export const fetchHundredBedsList = async () => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_HUNDRED_BEDS_LIST + `?timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
      .then((response) => {
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
};

/*** 
  @purpose : Get two hundred beds list
  @Parameter : {}
  **/
  export const fetchTwoHundredBedsList = async () => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_TWO_HUNDRED_BEDS_LIST + `?timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
      .then((response) => {
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
};

/*** 
  @purpose : Get evaluation target classification list
  @Parameter : {}
  **/
  export const fetchEvaluationTargetClassificationList = async () => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_EVALUATION_TARGET_CLASSIFICATION_LIST + `?timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
      .then((response) => {
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
};

/*** 
  @purpose : Get wholesaler level list
  @Parameter : {}
  **/
  export const fetchWholesalerLevelList = async (body) => {
    const token = sessionStorage.getItem("token");
    return fetch(API_URL + API.GET_WHOLESALER_LEVEL_LIST, {
      method: "post",
      headers: {
        'Access-Control-Allow-Origin': '*',
        'x-api-key': token ? token : ''
      },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return data;
      });
};

/*** 
@purpose : Get prefecture list
@Parameter : {}
**/
export const fetchSalesPrefectureList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_SALES_PREFECTURE_LIST + `?timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
  @purpose : Get county list
  @Parameter : {}
  **/
export const fetchCountyList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_SALES_COUNTY_LIST, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
  @purpose : Get wholesaler group list
  @Parameter : {}
  **/
  export const fetchWholesalerGroupList = async () => {
    const token = sessionStorage.getItem("token");
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.GET_WHOLESALER_GROUP_LIST + `?timestamp=${timestamp}`, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
      .then((response) => {
        // if (response.data.success == true && response.data.data) {
          return response;
        // }
      });
};

/*** 
@purpose : Get legal entity list
@Parameter : {}
**/
export const fetchLegalEntityList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_LEGAL_ENTITY_LIST, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get daily sellout report list
@Parameter : {}
**/
export const getDailySelloutReportList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_DAILY_SELLOUT_REPORT, {
    method: "post",
    headers: {
      'Access-Control-Allow-Origin': '*',
      'x-api-key': token ? token : 12345,
      'language': sessionStorage.getItem("Language")
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get daily sellout report list
@Parameter : {}
**/
export const getDailySelloutCAReportList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_DAILY_SELLOUT_REPORT, {
    method: "post",
    headers: {
      'Access-Control-Allow-Origin': '*',
      'x-api-key': token ? token : 12345,
      'language': sessionStorage.getItem("Language")
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get daily sellout report list
@Parameter : {}
**/
export const getMonthlySelloutReportList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_MONTHLY_SELLOUT_REPORT, {
    method: "post",
    headers: {
      'Access-Control-Allow-Origin': '*',
      'x-api-key': token ? token : 12345,
      'language': sessionStorage.getItem("Language")
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get daily sellout report list
@Parameter : {}
**/
export const getMonthlySelloutCAReportList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_MONTHLY_SELLOUT_REPORT, {
    method: "post",
    headers: {
      'Access-Control-Allow-Origin': '*',
      'x-api-key': token ? token : 12345,
      'language': sessionStorage.getItem("Language")
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get daily sellout report list
@Parameter : {}
**/
export const getSelloutRotationReportList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_SELLOUT_ROTATION_REPORT, {
    method: "post",
    headers: {
      'Access-Control-Allow-Origin': '*',
      'x-api-key': token ? token : 12345,
      'language': sessionStorage.getItem("Language")
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get daily sellout report list
@Parameter : {}
**/
export const getSelloutRotationCAReportList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_SELLOUT_ROTATION_REPORT, {
    method: "post",
    headers: {
      'Access-Control-Allow-Origin': '*',
      'x-api-key': token ? token : 12345,
      'language': sessionStorage.getItem("Language")
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get daily sellout report list
@Parameter : {}
**/
export const fetchMaintenanceList = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_MAINTENANCE_TIME, {
    method: "post",
    headers: {
      'x-api-key': token,
      'Access-Control-Allow-Origin': '*',
      'language': sessionStorage.getItem("Language")
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) { 
      return data;
    });
};

/*** 
  @purpose : Get reports list
  @Parameter : {}
  **/
  export const fetchReportsList = async () => {
    const token = sessionStorage.getItem("token");
    return await axios.get(API_URL + API.GET_REPORTS_LIST, {headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*'}})
      .then((response) => {
        if (response.data.success == true && response.data.data) {
          return response.data.data;
        }
      });
};

/*** 
@purpose : Get Downloaded file
@Parameter : {}
**/
export const downloadUserReport = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.GET_FILE, {
    method: "post",
    headers: {
      'x-api-key': token,
      'Access-Control-Allow-Origin': '*'
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) { 
      return data;
    });
};